import React from "react";
import { useTranslation } from "react-i18next";
import {
  useRetrieveCurrentPlanzone,
  useZonesProjectsRetrieval,
} from "@planzone/view-models";

import { Loader } from "../loader";
import { Checkbox } from "../checkbox";
import { ScrollPane } from "../scrollPane";
import { Section } from "../section";
import { filterSearch } from "../utils";
import { Props } from "./types";
import { Zone } from "./zone";
import { groupByZone } from "./utils";
import styles from "./styles.scss";

function Zones({ search, filter, setFilter, isOpen }: Props) {
  const { t } = useTranslation();
  const { planzone } = useRetrieveCurrentPlanzone();
  const {
    isRequestPending,
    isRequestSuccess,
    isRequestFailure,
    projects,
    retrieveZonesProjects,
  } = useZonesProjectsRetrieval();

  React.useEffect(() => {
    !isRequestPending &&
      !isRequestSuccess &&
      !isRequestFailure &&
      retrieveZonesProjects(planzone);
  }, []);

  return (
    <Section
      header={
        <div className={styles.header}>
          <Checkbox
            isChecked={filter && filter.length === 0}
            check={() => setFilter([])}
          />
          <p className={styles.title}>{t("common.filterMenu.zones.title")}</p>
        </div>
      }
      list={
        <ScrollPane>
          <div className={styles.list}>
            {!isRequestPending ? (
              [...filterSearch(groupByZone(projects), search)]
                .sort((a, b) => a.name.localeCompare(b.name))
                .map((zone) => (
                  <Zone
                    key={zone.uuid}
                    search={search}
                    zone={zone}
                    filter={filter}
                    setFilter={setFilter}
                  />
                ))
            ) : (
              <div className={styles.loader}>
                <Loader />
              </div>
            )}
          </div>
        </ScrollPane>
      }
      isHeaderToggleDisabled
      isOpen={isOpen}
    />
  );
}

export { Zones };
